import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import Quill styles

const toolbarOptions = [
    [{ 'font': [] }],
    [{ 'size': ['small', false, 'large', 'huge'] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ 'color': [] }, { 'background': [] }],
    [{ 'script': 'sub' }, { 'script': 'super' }],
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
    [{ 'align': [] }],
    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
    [{ 'indent': '-1' }, { 'indent': '+1' }],
    [{ 'direction': 'rtl' }],
    ['blockquote', 'code-block'],
    ['link', 'image', 'video'],
    ['clean']
  ];
  
  const modules = {
    toolbar: toolbarOptions
  };
  
const MyHtmlEditor = ({ value, onChange, placeholder = "Write something..." }) => {
    return (
      <ReactQuill 
        value={value} 
        onChange={onChange} 
        modules={{
            toolbar: [
              [{ header: [1, 2, false] }],
              ["bold", "italic", "underline"],
              [{ 'align': [] }],
              [{ 'list': 'ordered' }, { 'list': 'bullet' }],
              ["link"]
            ]
          }}
        placeholder={placeholder}
        theme="snow" // You can change to "bubble" if needed
        style={{ textTransform: 'uppercase' }} // Ensure text is displayed in uppercase
      />
    );
  };

export default MyHtmlEditor;
